import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

interface UsePutResourceCategoryParams {
  onSuccess?: () => void
  onError?: () => void
}

export interface PutResourceCategoryPayload {
  id: number
  name: string
  displayOrder?: number
}

export const usePutResourceCategory = ({
  onSuccess,
  onError,
}: UsePutResourceCategoryParams = {}) => {
  const queryClient = useQueryClient()
  const put = useTypedApiClient({
    path: '/admin/resources/categories/{id}',
    method: 'put',
  })

  return useMutation({
    mutationKey: ['/admin/resources/categories/{id}', 'put'],
    mutationFn: async (payload: PutResourceCategoryPayload) => {
      const { data } = await put({
        id: payload.id,
        name: payload.name,
        displayOrder: payload.displayOrder,
      })

      return data
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['/admin/resources/categories'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['/admin/resources'],
        }),
      ])
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })
}
